//#region GIMmanager payload types

/**
 *
 */
export const DESKTOP_APP_LATEST_VERSION = 'DESKTOP_APP_LATEST_VERSION';

/**
 *
 */
export const DESKTOP_APP_CURRENT_VERSION = 'DESKTOP_APP_CURRENT_VERSION';

/**
 *
 */
export const DESKTOP_APP_UPDATE_AVAILABLE = 'DESKTOP_APP_UPDATE_AVAILABLE';

/**
 * Manager capability ready action.
 */
export const MANAGER_READY = 'MANAGER_READY';

/**
 * Manager capability unavailable action.
 */
export const MANAGER_NOT_READY = 'MANAGER_NOT_READY';

/**
 * SignalR transport connected action.
 */
export const MANAGER_TRANSPORT_CONNECTED = 'MANAGER_TRANSPORT_CONNECTED';

/**
 * SignalR transport disconnected action.
 */
export const MANAGER_TRANSPORT_DISCONNECTED = 'MANAGER_TRANSPORT_DISCONNECTED';

/**
 *
 */
export const DESKTOP_APP_UPDATE_MANDATORY = 'DESKTOP_APP_UPDATE_MANDATORY';

/**
 *
 */
export const SET_MANAGER_API_TOKEN = 'SET_MANAGER_API_TOKEN';

//#endregion
